import React from 'react';
import { Link } from 'utils/AppLink';
import { toAssetsExtUrl } from 'utils/assetsExtUrl';
import BZPersonIcon from 'web-common/bizzabo-components/components/BZPersonIcon';
import classname from 'classnames';

const emptyPersonIcon = '/images/agenda/SpeakerIcon.png';

export default ({
    classLink = '',
    sizeImage = 'medium',
    context: {agendaUrl},
    classInfo = '',
    speaker: {
        id,
        firstname,
        lastname,
        fullName,
        thumbnailSet = { small: null, medium: null, large: null },
        thumbnailUrl, role, company, title
    },
    isWidget
}) => {

    const personIcon = toAssetsExtUrl(thumbnailSet[sizeImage] || thumbnailUrl);
    const classHolder = classname({ borderOnImage: !personIcon });
    const rootClass = classname('agenda-flex speaker-slide', classLink);
    const infoClass = classname('speaker-info', classInfo);
    const isWidgetParam = isWidget ? '?widget=true' : '';
    const speakerUrl = `${agendaUrl}/speakers/${id}${isWidgetParam}`;
    return <Link className={rootClass} to={speakerUrl}>
        {!id && <div className="speaker-photo image-placeholder"/>}
        {id &&
        <BZPersonIcon
            lastName={firstname}
            firstName={lastname}
            classHolder={classHolder}
            urlImage={personIcon || emptyPersonIcon}
            className="speaker-photo agenda-flex agenda-flex-align-items-center padding-none"
        />
        }
        <div className={infoClass}>
            <div className='speaker-name font-size-14'> {fullName} </div>
            {title && <div className='speaker-title text-ellipsis font-size-12'> {title} </div>}
            {company && <div className='speaker-company text-ellipsis font-size-12'> {company} </div>}
            {role && <div className='speaker-position text-ellipsis font-size-12'> {role} </div>}
        </div>
    </Link>;
};
